import AppMainTeam from './app-main-team';

export default AppMainTeam;
